import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));
function SwitchInput(props) {
    const classes = useStyles();
    const [Value,setValue] = React.useState(props.Value)
    const handleChange=(e)=>{
        //console.log(date)
        setValue(e.target.checked===true?1:0)
        props.onchangeHanelEvent(props.Meta,e.target.checked===true?1:0)
    }
    return (
        <div className="d-flex"  style={{ height: 'auto' }}>
            <div>
                <p style={{ marginTop: '7px', marginRight: '1rem' }}>{props.Label}</p>
            </div>
            <div>
                   <Switch
                   checked={(Value===1)?true:false}
                   name="Laperut"
                   color="primary"
                   onChange={handleChange}
                   />
            </div>
        </div>
    );
}

export default SwitchInput;